import { useContext } from "react";
import { NotifyProps } from "./NotificationsProvider";
import { NotificationContext } from "./NotificationContext";

export const useNotify = (): ((props: NotifyProps) => void) => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotify must be used within a NotificationProvider");
  }
  return context.notify;
};
